import { render, staticRenderFns } from "./Services_rate.vue?vue&type=template&id=5d2560ca&scoped=true&"
import script from "./Services_rate.vue?vue&type=script&lang=js&"
export * from "./Services_rate.vue?vue&type=script&lang=js&"
import style0 from "./Services_rate.vue?vue&type=style&index=0&id=5d2560ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2560ca",
  null
  
)

export default component.exports